import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Philosophy from './components/Philosophy';
import Catalog from './components/Catalog';
import Waitlist from './components/Waitlist';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('all');

  return (
    <Router>
      <div className="app">
        <Navigation />
        <main>
          <Hero />
          <About />
          <Philosophy />
          <Catalog activeTab={activeTab} setActiveTab={setActiveTab} />
          <Waitlist />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

